@if (showRedirectScreen$ | async) {
  <div class="fixed inset-0 bg-secondary-900/70 backdrop-blur-md z-[999997] flex items-center justify-center">
    <div class="h-20 bg-secondary-900/30 blur-xl d z-[999998] w-80 rounded-4xl fixed">
    </div>
    <h3 class="fixed  z-[999999] font-bold text-grey-50">Redirecting please wait...</h3>
  </div>
}